import {
    useEffect,
} from "preact/hooks";

import type {
    RefObject,
} from "preact";

export const useClickOutside = (
    refs: RefObject<HTMLElement | null>[],
    onClickOutside: () => void,
): void => {
    useEffect(() => {
        const handleMouseDown = (event: MouseEvent): void => {
            const target = event.target as Node;
            const isOutside = refs.every(
                (ref) => !ref.current?.contains(target),
            );
            if (isOutside) {
                onClickOutside();
            }
        };

        document.addEventListener("mousedown", handleMouseDown);
        return () => document.removeEventListener("mousedown", handleMouseDown);
    }, [refs, onClickOutside]);
};
